import Crud from '../views/Agendamento/Crud'
import Entity from '../views/Agendamento/View'

let routes = {
    path: '/agendamentos',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/agendamentos/view/:id?',
            name: 'ViewAgendamento',
            component: Entity,
            meta: {
                pageTitle: "Visualizar Agendamentos",
                breadcrumb: [
                    {
                        text: "Agendamentos",
                        active: false,
                        to: '/agendamentos',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/agendamentos',
            name: 'list-agendamentos',
            component: Crud,
            meta: {
                pageTitle: "Lista de Agendamentos",
                breadcrumb: [
                    {
                        text: "Agendamentos",
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
